export class ItemUnitsFilterEntity {
    isActive?: boolean
    searchWord?: string
    page?: number
    limit?: number
}
